import { getGlobalNavigate } from "./navigation";

export const logoutCompletely = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");

  sessionStorage.setItem("sessionExpired", "true");

  const navigate = getGlobalNavigate();
  if (navigate) {
    setTimeout(() => {
      navigate("/login");
    }, 150);
  } else {
    console.warn("⚠️ navigate is not available, using window.location");

    setTimeout(() => {
      window.location.replace("/#/login");
    }, 150);
  }
};
